import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { ActionReducer, StoreModule, MetaReducer } from '@ngrx/store';

import { HttpClientModule } from '@angular/common/http';
import { NgbActiveModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppComponent } from './app.component';

import * as fromContainers from './containers';
import * as fromComponents from './components';
import * as fromStateManagement from './store'
import * as fromServices from './services';

import { storeLogger } from 'ngrx-store-logger';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { EffectsModule } from '@ngrx/effects';
import { RouterModule, Routes } from '@angular/router';

import * as Honeybadger from "@honeybadger-io/js";

Honeybadger.configure({
  apiKey: "hbp_fK3EpMbTVGSLdc8rsCHnE6GmTGYRI82XfroA",
  environment: "production",
  breadcrumbsEnabled: false
});

class HoneybadgerErrorHandler implements ErrorHandler {
  handleError(error: any) {
    Honeybadger.notify(error.originalError || error);
  }
}


declare global {
  interface Window {
    environment: string | null;
  }
}

export function log(reducer: ActionReducer<any>): ActionReducer<any> {
  const verbose = true;

  if (window['environment'] === 'Development') {
    return storeLogger()(reducer);
  } else {
    return storeLogger()(reducer);
    // return storeLogger(window['appConfig']['loggingOption'])(reducer);
  }
}

const metaReducers: MetaReducer<any>[] = [log];

const reducers = {
  ...fromStateManagement.reducers
}

const route: Routes = [{
  path: '**',
  component: fromContainers.LandingPageComponent
}];

@NgModule({
  declarations: [
    AppComponent,
    ...fromComponents.components,
    ...fromContainers.containers
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    StoreModule.forRoot(reducers, { metaReducers }),
    StoreDevtoolsModule.instrument(),
    EffectsModule.forRoot([
      ...fromStateManagement.effects
    ]),
    RouterModule.forRoot(route, {}),
    NgbModule
  ],
  providers: [
    {provide: ErrorHandler, useClass: HoneybadgerErrorHandler},
    fromServices.services,
    NgbActiveModal
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
